import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'RECEITA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setFiltro(filtro) {
    return {
        type: 'RECEITA_SET_FILTRO',
        payload: filtro
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'RECEITA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('receitaForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {

		dispatch(setAguardando(true));

		const filtro = getState().receita.filtro;

		axios.get(`${consts.API_URL}/receita?padrao=true
			&data_inicial=${getState().receita.filtro.data_inicial}
			&data_final=${getState().receita.filtro.data_final}
			${(filtro.ids_empresa || []).length ? `&ids_empresa=${filtro.ids_empresa.join(',')}` : ''}
            ${(filtro.ids_centro_custo || []).length ? `&ids_centro_custo=${filtro.ids_centro_custo.join(',')}` : ''}
            ${(filtro.ids_analitica || []).length ? `&ids_analitica=${filtro.ids_analitica.join(',')}` : ''}
            ${(filtro.ids_forma_pagamento || []).length ? `&ids_forma_pagamento=${filtro.ids_forma_pagamento.join(',')}` : ''}
            ${(filtro.ids_destinatario || []).length ? `&ids_destinatario=${filtro.ids_destinatario.join(',')}` : ''}
		`).then(result => {
			dispatch({
				type: 'RECEITA_LISTADO',
				payload: result
			});
			dispatch(setAguardando(false));
		}).catch(ex => {
			setErroAPI(ex);
			dispatch(setAguardando(false));
		});
	};
}

export function salvar(registro, continuarLancamento = false) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/receita`, {
				...registro,
				data_vencimento: registro.data_vencimento || registro.data_pagamento || registro.data_receita,
				data_pagamento: registro.data_pagamento ? registro.data_pagamento : (registro.data_vencimento ? null : registro.data_receita),
				valor: FormatUtils.formatarValorBanco(registro.valor, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				if (continuarLancamento) {
					dispatch(initForm({
						...registro,
						valor: '',
						observacao: ''
					}));
				} else {
					dispatch(setModoTela('lista'));
				}
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/receita`, {
				...registro,
				valor: FormatUtils.formatarValorBanco(registro.valor, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function alterarGeral(lista, registro, evento) {
    return async (dispatch, getState) => {		

		for (let i = 0; i < lista.length; i++) {
			const item = lista[i];
		
			await axios.put(`${consts.API_URL}/receita`, {
				...item,
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				
			}).catch(e => {
				setErroAPI(e);
			});
		}

		setSuccess('Operação Realizada com sucesso.');
		dispatch(getLista());
		dispatch(setModoTela('lista'));
		evento();

    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/receita?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}